import { useCallback, useSyncExternalStore } from "react";
import { effect } from "alien-signals";

// Signal type: a function that can get/set values
export type Signal<T> = (value?: T | ((val: T) => T)) => T;

export function useSignal<T>(signal: Signal<T>): T {
  const value = useSyncExternalStore(
    (callback) =>
      effect(() => {
        signal(); // Track
        callback(); // Notify React
      }),
    () => signal(),
    () => signal(),
  );
  return value;
}
